
const AuthorCollection = Backbone.Collection.extend({
    model: AuthorModel,
});

// "Static" method that returns all the authors of the database in an ordered fashion
AuthorCollection.all = function() {
    let authors = window.reads_data.author.map(function(el) {
        // Remove the extra whitespace that is at the beggining of the string
        // (otherwise it messes with the sorting function)
        var name = el.name.replace(/^ /g, "");
        // Format: Lastname, first name
        return name.split(" ").slice(-1).join(" ") + ", " + name.split(" ").slice(0, -1).join(" ");
    }).sort();

    authors = _.uniq(authors);

    let authorModels = [];
    for (var i = 0; i < authors.length; i++) {
        authorModels.push(new AuthorModel({ id: null, name: authors[i] }));
    }

    return new AuthorCollection(authorModels);
};